import { Input } from "antd";
import React, { useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";

function SearchBar(props) {
  // MARK: --- Params ---
  const {
    type,
    name,
    placeholder,
    disabled,
    className,
    onSubmit,
    value,
    hintText,
  } = props;
  const typingTimeoutRef = useRef(null);
  const [text, setText] = useState(value);

  // MARK: --- Functions ---
  function handleTextChanged(e) {
    const value = e.target.value;
    setText(value);

    if (!onSubmit) {
      return;
    }

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      onSubmit(value);
    }, 500);
  }

  return (
    <div>
      <div className={`input-icon mr-2 ${className}`}>
        <Input
          id={name}
          type={type}
          className="form-control"
          placeholder={placeholder}
          value={text}
          onChange={handleTextChanged}
          prefix={<SearchOutlined />}
          style={{
            height: "44px",
            width: "360px",
          }}
        />
        <span>
          <i className="fal fa-search text-muted"></i>
        </span>
      </div>
      {/* {!_.isEmpty(hintText) && (
        <span className="form-text text-muted">{hintText}</span>
      )} */}
    </div>
  );
}

export default SearchBar;
